/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import PageForm from '../components/form';
import { CREATE_PAGE } from '../../../queries/page';

interface IAddPageProps {
  setIsDrawerOpen: any;
  refetch: any;
}

export const AddPage: React.FC<IAddPageProps> = ({ refetch, setIsDrawerOpen }) => {
  return (
    <Mutation
      mutation={CREATE_PAGE}
      update={async () => {
        await refetch();
      }}
    >
      {(createPage: any) => (
        <PageForm mutateData={createPage} setIsDrawerOpen={setIsDrawerOpen} />
      )}
    </Mutation>
  );
};
